import { ADD_TOAST, REMOVE_TOAST, HIDE_TOAST } from "../generic/types";

const addToast = (id, type, title, text, delay) => ({
  type: ADD_TOAST,
  toastInfo: { id, type, title, text, delay, isShowing: true }
});

const hideToast = (id) => ({
  type: HIDE_TOAST,
  id
});

const removeToast = (id) => ({
  type: REMOVE_TOAST,
  id
});

export const addToastAction =
  (type, title, text, delay = 3000) =>
  (dispatch) => {
    const toastId = "" + Date.now() + Math.random() + Math.random();
    dispatch(addToast(toastId, type, title, text, delay));
  };

export const hideToastAction =
  (toastId, removeDelay = 1000) =>
  (dispatch) => {
    setTimeout(() => {
      dispatch(removeToast(toastId));
    }, removeDelay);
    dispatch(hideToast(toastId));
  };

const closeToastAction = (toastId) => (dispatch) => {
  dispatch(removeToast(toastId));
};
